import React, { useMemo } from 'react';

import PropTypes from 'prop-types';

import { ReactComponent as BarstoolLogo } from 'assets/images/affiliateLogos/barstool.svg';
import { ReactComponent as GolfNowLogo } from 'assets/images/affiliateLogos/golf-now.svg';
import { ReactComponent as GolfDigestLogo } from 'assets/images/affiliateLogos/golf-digest.svg';
import { ReactComponent as GrouponLogo } from 'assets/images/affiliateLogos/groupon.svg';
import { ReactComponent as TeeOffLogo } from 'assets/images/affiliateLogos/tee-off.svg';

import Text from 'components/shared/ui/Text';

import { useDimension } from 'hooks/useDimensions';

const OurAffiliates = ({ className }) => {
  const { width } = useDimension();

  const styles = useMemo(() => {
    if (width > 1150) {
      return {
        container: { height: '112px', padding: '0 44px' },
        barstoolLogo: { width: '147px', height: '48px' },
        golfNowLogo: { width: '259px', height: '28px' },
        golfDigestLogo: { width: '154px', height: '32px' },
        teeOffLogo: { width: '146px', height: '36px' },
        grouponLogo: { width: '150px', height: '24px' },
      };
    }
    if (width > 880) {
      return {
        container: { height: '112px', padding: '0 34px' },
        barstoolLogo: { width: '112px', height: '37px' },
        golfNowLogo: { width: '197px', height: '22px' },
        golfDigestLogo: { width: '118px', height: '25px' },
        teeOffLogo: { width: '111px', height: '28px' },
        grouponLogo: { width: '114px', height: '19px' },
      };
    }
    if (width > 614) {
      return {
        container: { height: '64px', padding: '0 24px' },
        barstoolLogo: { width: '85px', height: '28px' },
        golfNowLogo: { width: '149px', height: '16px' },
        golfDigestLogo: { width: '89px', height: '19px' },
        teeOffLogo: { width: '84px', height: '21px' },
        grouponLogo: { width: '86px', height: '14px' },
      };
    }
    if (width > 416) {
      return {
        container: { height: '119px', padding: '21px 20px', flexDirection: 'column' },
        innerContainerA: { gap: '26px' },
        innerContainerB: { gap: '26px' },
        barstoolLogo: { width: '100px', height: '33px' },
        golfNowLogo: { width: '149px', height: '17px' },
        golfDigestLogo: { width: '106px', height: '22px' },
        teeOffLogo: { width: '89px', height: '22px' },
        grouponLogo: { width: '100px', height: '17px' },
      };
    }
    return {
      container: { height: '88px', padding: '16px 14px', flexDirection: 'column' },
      innerContainerA: { gap: '20px' },
      innerContainerB: { gap: '20px' },
      barstoolLogo: { width: '74px', height: '24px' },
      golfNowLogo: { width: '110px', height: '12px' },
      golfDigestLogo: { width: '78px', height: '16px' },
      teeOffLogo: { width: '66px', height: '16px' },
      grouponLogo: { width: '74px', height: '12px' },
    };
  }, [width]);

  return (
    <section className={className}>
      <div className="w-full max-w-300">
        <Text variant="h3">Our affiliates</Text>
        <p className="pt-1 font-primary-two text-4 leading-5 -tracking-0.2 text-dark md:pt-2">Partners and sites we search.</p>
        <div className="flex items-center justify-between bg-white-two rounded-2 mt-4 md:mt-6" style={styles.container}>
          {width > 614 ? (
            <>
              <BarstoolLogo style={styles.barstoolLogo} />
              <GolfNowLogo style={styles.golfNowLogo} />
              <GolfDigestLogo style={styles.golfDigestLogo} />
              <TeeOffLogo style={styles.teeOffLogo} />
              <GrouponLogo style={styles.grouponLogo} />
            </>
          ) : (
            <>
              <div className="flex items-center justify-center" style={styles.innerContainerA}>
                <BarstoolLogo style={styles.barstoolLogo} />
                <GolfNowLogo style={styles.golfNowLogo} />
              </div>
              <div className="flex items-center justify-center" style={styles.innerContainerB}>
                <GolfDigestLogo style={styles.golfDigestLogo} />
                <TeeOffLogo style={styles.teeOffLogo} />
                <GrouponLogo style={styles.grouponLogo} />
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

OurAffiliates.defaultProps = {
  className: '',
};

OurAffiliates.propTypes = {
  className: PropTypes.string,
};

export default OurAffiliates;
